import React from "react";

export default function Placeholder({ title, subtitle }) {
  return (
    <div className="animate-in fade-in duration-300">
      <h1 className="text-[22px] font-semibold tracking-tight text-[#F4F5F8]">{title}</h1>
      <div className="mt-6 rounded-2xl border border-dashed border-[#2A3040] bg-[#151A24] p-14 text-center">
        <p className="text-[15px] font-medium text-[#C4C9D4]">{subtitle || `${title} is coming soon`}</p>
        <p className="mt-1 text-[13.5px] text-[#6E7686]">This section arrives in a later phase.</p>
      </div>
    </div>
  );
}
